import React from 'react';
import ServiceFeeItem from '../../../Domain/ServiceFeeItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import CurrencyLabelGenerator from '../../../Elements/CurrencyLabelGenerator';
import ServiceFeeService from '../../../Services/ServiceFeeService';

// Drives the GeneralEditWizzardBaseFigma create/edit wizard for a service's Other Fees.
// Three fields keep it in the compact centered DS modal. The Amount label is currency-aware
// (resolved from the edited item's PurchaseAmtCurId by InputWithClear).
export default class OtherFeeWindowDescription {
  static titleForCreate = 'Add Other Fee';
  static titleForEdit = 'Edit Other Fee';
  static entityName = 'Other Fee';
  static idField = 'ServiceFeeId';
  static nameField = 'Description';
  static itemType = ServiceFeeItem;
  static serviceFunction = ServiceFeeService.PostServiceFee;
  static messageOnSuccess = 'Other Fee has been saved.';
  static finishButtonLabel = 'Save';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'TypeId',
          label: 'Fee Type',
          className: 'col-6',
          type: InputTypesEnum.ServiceFeeTypeLookupSelect,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Amount',
          label: (item) => <CurrencyLabelGenerator labelText={'Fee Amount {Value}'} id={item.PurchaseAmtCurId} />,
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Description',
          label: 'Description',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    },
  ];
}
